import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=3b74bd2e&scoped=true&"
import script from "./BlogList.vue?vue&type=script&lang=js&"
export * from "./BlogList.vue?vue&type=script&lang=js&"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=3b74bd2e&lang=scss&scoped=true&"
import style1 from "./BlogList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74bd2e",
  null
  
)

export default component.exports